export const dataUriToBlob = (dataUri: string) => {
	const byteString = atob(dataUri.split(',')[1])
	const mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0]
	const ab = new ArrayBuffer(byteString.length)
	const ia = new Uint8Array(ab)
	for (let i = 0; i < byteString.length; i++) {
		ia[i] = byteString.charCodeAt(i)
	}
	return new File([ab], 'image.png', { type: mimeString })
}
